import { OriginMaterial } from "./../pages/media/material";

export enum NativeMaterialStatus {
  EXPIRED = 0, // 授权过期
  APPLYING = 1, // 申请中
  AUTHORIZED = 2, // 已授权
  NORESPONSE = 3, // 授权未响应
  REJECTED = 4, // 授权拒绝
  CANCEL = 5, // 授权取消
}
export interface NativeMaterialItem {
  [key: string]: any;
  item_id: string;
  status: NativeMaterialStatus;
  text: string; // ad text
  video_info: {
    [key: string]: any;
    vid: string;
    cover_url: string;
    play_url: string;
    bitrate: number;
    width: number;
    height: number;
    size: number;
    duration: number;
  };
}

export interface NativeMaterialInfo extends NativeMaterialItem {
  origin: OriginMaterial;
}
